import { FC } from 'react';

type Props = {
	className?: string;
};

const NotificationIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M4.00041 8.00006V10.1374C4.00041 10.5617 3.83184 10.9686 3.53177 11.2687L2.40039 12.4001V13.5057C2.40039 13.8087 2.57011 14.0873 2.84739 14.2096C4.12158 14.7713 6.61553 15.6001 10.0005 15.6001C13.3854 15.6001 15.8793 14.7713 17.1536 14.2096C17.4308 14.0873 17.6005 13.8087 17.6005 13.5057V12.4001L16.4692 11.2687C16.1691 10.9686 16.0005 10.5617 16.0005 10.1374V8.00006C16.0005 4.68631 13.3142 2 10.0005 2C6.68672 2 4.00041 4.68631 4.00041 8.00006Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.8002 15.6C12.8002 16.9255 11.5284 18 9.97774 18C8.42709 18 7.2002 16.9255 7.2002 15.6'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default NotificationIcon;
